import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Event } from 'app/core/models/event.model';
import { ENV } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private _http: HttpClient) { }

  getEventBySapCode(sapCode: string): Observable<Event> {
    return this._http.get<Event>(`${ENV.BASE_PATH.EVENT}/public/events/searchBySapCode?sapCode=${sapCode}`);
  }

}
